import * as Types from '../types/Company';
import {PAGINATION} from '../../constants/define';
// import HotelRequest from "../mapping/Request/HotelRequest";

const initialState = {
    isFetching: false,
    all: [],
    errors: [],
    masterData: {},
    // item: new HotelRequest().update(),
    item: {},
    data: {
        result: [],
        page_size: PAGINATION.page_size,
        page_index: PAGINATION.page_index,
        total: PAGINATION.total,
        total_page: PAGINATION.total_page,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.COMPANY_LIST_ACTION:
        case Types.COMPANY_CREATE_ACTION:
        case Types.COMPANY_UPDATE_ACTION:
        case Types.COMPANY_MASTER_DATA_ACTION:
        case Types.COMPANY_GET_TEM_ACTION:
            return {...state, isFetching: true};
        case Types.COMPANY_LIST_SUCCESS:
            return {...state, isFetching: false, data: action.company};
        case Types.COMPANY_CREATE_SUCCESS:
            return {...state, isFetching: false};
        case Types.COMPANY_UPDATE_SUCCESS:
            return {...state, isFetching: false};
        case Types.COMPANY_MASTER_DATA_SUCCESS:
            return {...state, isFetching: false, masterData: action.masterData};
        case Types.COMPANY_GET_TEM_SUCCESS:
            return {...state, isFetching: false, item: action.item};
        case Types.COMPANY_FAILED:
            return {...state, isFetching: false, errors: action.errors};
        case Types.COMPANY_INIT:
            return initialState;
        default:
            return state;
    }
}
